import { ChangeDetectionStrategy, Component, model, OnChanges, OnInit, signal, viewChild, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { lastValueFrom } from "rxjs";
import { PhxSelect } from "../../../../shared/components/phx-select/phx-select.component";
import { CustomEntitySchemaService } from "../../services/custom-entity-schema.service";

type SelectOption = { label: string, value: string };

@Component({
  selector: 'app-custom-entity-relation-drop-down',
  imports: [
    PhxSelect,
  ],
  templateUrl: './custom-entity-relation-drop-down.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomEntityRelationDropDownComponent extends FieldType<FieldTypeConfig> implements OnInit, OnChanges {
  systemRelations = [
    "Product",
    "Address",
    "Document",
    "Employee",
    "User",
    "Department",
    "Role",
    "ProductGroup",
  ];

  value = model<string>();
  selectOptions = signal<SelectOption[]>([]);
  placeholder = model<string>('');
  hideSystemRelations = model<boolean>(false);

  selectComponent = viewChild<PhxSelect<string>>("selectComponent");

  constructor(
    private customEntitySchemaService: CustomEntitySchemaService,
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.props?.placeholder)
      this.placeholder.set(this.props.placeholder);

    if (this.props?.hideSystemRelations !== undefined && this.props?.hideSystemRelations !== null)
      this.hideSystemRelations.set(this.props.hideSystemRelations);

    if (this.formControl.value)
      this.value.set(this.formControl.value);

    this.refresh();
  }

  ngOnChanges(change) {
    if (change?.hideSystemRelations)
      this.refresh();
  }

  async refresh() {
    let result: SelectOption[] = [];
    if (!this.hideSystemRelations()) {
      if (this.selectComponent()?.filterValue())
        result = this.systemRelations
          .filter(x => x.toLowerCase().indexOf(this.selectComponent()?.filterValue().toLowerCase()) > -1)
          .map(x => ({ label: x, value: x } as SelectOption));
      else
        result = this.systemRelations
          .map(x => ({ label: x, value: x } as SelectOption));
    }

    let entities = (await lastValueFrom(this.customEntitySchemaService.getItems({ term: this.selectComponent()?.filterValue() ?? undefined }).single$))?.getCustomEntitySchemas?.items ?? [];
    for (let entity of entities) {
      let label = entity.displayName ?? entity.identifier;

      result.push({ label: label, value: entity.identifier } as SelectOption);
    }

    this.selectOptions.set(result);
    this.selectComponent()?.loading?.set(false);

    return result;
  }
}
